import { z } from 'zod';
/**
 * Shared enum for the Mongoose `assignedToModel` discriminator on
 * ProcessStepAssignment / ProcessStepRecording — kept in one place so
 * mutation contracts and entity schemas stay aligned.
 *
 * `'OrgFunction'` (formerly `'Team'`) resolves into the unified `orgFunctions`
 * collection and is a valid assignee for both kinds — a step can be assigned to
 * a team-kind OrgFunction or a role-kind OrgFunction (e.g. the Datenschutzbeauftragter).
 */ export const AssigneeModelSchema = z.enum([
    'User',
    'OrgFunction',
    'System',
    'ExternalContact'
]);

//# sourceMappingURL=assignee-model.schema.js.map